<template>
  <div v-if="studies && userInfo" class="landingPage">
		<v-container class="landing-page-container">
      <v-row
      >
        <v-col
          sm="9"
					md="8"
					lg="9"
        >
					<v-row>
						<v-col>
							<banner-message></banner-message>
						</v-col>
					</v-row>
					<v-row no-gutters>
						<h1 class="d-sr-only">Researcher Site Landing Page</h1>
						<v-col cols="12" md="4" lg="6">
						<h2 v-if="userInfo.firstName" class="text-h4 left-align header-left-align font-weight-regular" tabindex="0">Hello {{ userInfo.firstName }}!</h2>
						<h2 v-else class="text-h4 left-align header-left-align font-weight-regular" tabindex="0">Hello!</h2>
						<p>
							<v-select
								ref="firstFocusable"
								:items="sortItems"
								label="Sort by:"
								v-model="studiesSortProperty"
								style="max-width:600px"
								item-color="black"
							></v-select>
						</p>
						</v-col>
						<v-col cols="12" md="8" lg="6">
							<v-img aria-hidden="true" alt="" contain :src="require('@/assets/logoAsa24.png')" :max-width="600" ></v-img>
						</v-col>
					</v-row>
					<!-- This is displayed when there are no items returned for the studies call -->
					<div v-if="isEmpty(storeStudies)">
						<v-card class="study-card">
							<v-list-item>

								<v-list-item-avatar
									tile
									size="70"
								>
									<v-img aria-hidden="true" alt="" contain :src="require('@/assets/logoPlatterIcon.png')" :aspect-ratio="1/1" :max-width="70"></v-img>
								</v-list-item-avatar>
								<v-list-item-content>
									<v-list-item-title>
										<h2>Welcome to the ASA24 Researcher Site</h2>
									</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
							<v-card-text>
								<p class="p2 left-align" id="welcomeText">
									Welcome to the researcher website for the Automated Self-Administered 24-Hour Dietary Assessment Tool (ASA24®).
									This website allows researchers, clinicians, and educators to register to use the ASA24 system; to manage
									logistics of data collection; and to obtain analytic output files.
								</p>
							</v-card-text>
							<v-card-actions>
								<v-btn v-if="displayAlterText" class="btn-default" text @click="onNewStudy()">Create a New Study (Draft Saved)</v-btn>
								<v-btn v-else class="btn-default" text @click="onNewStudy()">Create a New Study</v-btn>
							</v-card-actions>
						</v-card>
					</div>
					<!--
						This displays the studies with each one having its own card,
						the titles can be clicked for getting more information and actions
						on the study
					-->
					<div v-if="!isEmpty(storeStudies)">
						<v-row no-gutters>
							<v-col
								v-for="study in storeStudies"
								v-show="study.currentStudyStatus && study.currentStudyStatus.toLowerCase() !== 'draft'"
								:key="study.studyUuid"
								sm="18"
								md="12"
								lg="6"
								class="study-card-container flex-grow-1 flex-shrink-1"
							>
								<v-card
									class="study-card"
								>
									<v-list-item
										class="study-card-title left-align"
										@click="studyClicked(study.studyUuid, study.currentStudyStatus)"
										@keyup.enter="studyClicked(study.studyUuid, study.currentStudyStatus)"
										role="link"
										tabindex="0"
									>
										<v-list-item-content >
											<v-list-item-title class="study-card-headline"><h2 class="studyCardHeader"> {{ study.studyName }} ({{ study.studyId }})</h2></v-list-item-title>
										</v-list-item-content>
										<span class="study-card-headline font-italic">Go to study<v-icon color="#FFFFFF">mdi-arrow-right</v-icon></span>
									</v-list-item>

									<v-row
										class="mb-6"
										no-gutters
										v-if="study.currentStudyStatus && study.currentStudyStatus.toLowerCase() === 'created'"
									>
										<v-col class="firstColHomeCard">
											<v-card
												class="card-study-details"
												color="transparent"
												max-width="95%"
												outlined
												tile
											>
												<v-card-subtitle class="card-study-section">
													<h3>STUDY DETAILS</h3>
												</v-card-subtitle>
												<v-divider></v-divider>
												<v-list-item two-line>
													<v-list-item-avatar><v-icon x-large>event_note</v-icon></v-list-item-avatar>
													<v-list-item-content>
														<v-list-item-subtitle class="left-align">Study Start - Study End</v-list-item-subtitle>
														<v-list-item-title class="left-align">{{convertToDate(study.dateStart)}} - {{convertToDate(study.dateEnd)}}</v-list-item-title>
													</v-list-item-content>
												</v-list-item>
												<v-list-item two-line>
													<v-list-item-avatar><v-icon x-large>{{getStudyToolInfo(study).icon}}</v-icon></v-list-item-avatar>
													<v-list-item-content>
														<v-list-item-title class="left-align">{{getStudyToolInfo(study).type}} Study</v-list-item-title>
														<!-- TODO: Add versionDescription to the study object in order to display it here -->
														<v-list-item-subtitle class="left-align">{{getStudyVersionDescription(study.version)}}</v-list-item-subtitle>
													</v-list-item-content>
												</v-list-item>
												<v-list-item two-line>
													<v-list-item-avatar><v-icon x-large>{{getStudyTypeInfo(study.studyTool, study.recordStudyType, study.recallType).icon}}</v-icon></v-list-item-avatar>
													<v-list-item-content>
														<v-list-item-title class="left-align">
															<span>Study type: </span>
															{{getStudyTypeInfo(study.studyTool, study.recordStudyType, study.recallType).type}}
														</v-list-item-title>
														<!-- <v-list-item-subtitle class="left-align">
															Goal:
															<span v-if="getStudyToolInfo(study) == typeList[1]"> {{study.numrecallsperparticipant}} </span>
															<span v-if="getStudyToolInfo(study) == typeList[2]"> {{study.numrecordsperparticipant}} </span>
															/ person
														</v-list-item-subtitle> -->
													</v-list-item-content>
												</v-list-item>
											</v-card>
										</v-col>
										<v-divider vertical inset></v-divider>
										<v-col >
											<v-card
												class="card-participant-details"
												max-width="95%"
												outlined
												tile
												color="transparent"
											>
												<v-card-subtitle class="card-study-section">
													<h3>PARTICIPANT DETAILS</h3>
												</v-card-subtitle>
												<v-divider></v-divider>
												<div v-if="study.countRespondents > 0">
													<v-list-item two-line>
														<v-list-item-avatar><v-icon x-large>group</v-icon></v-list-item-avatar>
														<v-list-item-content>
															<v-list-item-subtitle class="left-align">Participants</v-list-item-subtitle>
															<v-list-item-title class="left-align">{{study.countRespondents}}</v-list-item-title>
														</v-list-item-content>
													</v-list-item>
													<v-list-item two-line>
														<v-list-item-avatar><v-icon x-large>done</v-icon></v-list-item-avatar>
														<v-list-item-content>
															<v-list-item-subtitle class="left-align">Complete Responses</v-list-item-subtitle>
															<v-list-item-title class="left-align">{{study.countRecallComplete}}</v-list-item-title>
														</v-list-item-content>
													</v-list-item>
													<v-list-item two-line>
														<v-list-item-avatar><v-icon x-large>not_interested</v-icon></v-list-item-avatar>
														<v-list-item-content>
															<v-list-item-subtitle class="left-align">Quit Responses</v-list-item-subtitle>
															<v-list-item-title class="left-align">{{study.countRecallQuit}}</v-list-item-title>
														</v-list-item-content>
													</v-list-item>
												</div>
												<div v-else>
													<br>
													<v-btn class="btn-default" text :aria-label="'Create Respondents for ' + study.studyName + ' (' + study.studyId + ') study'" @click="onNewRespondents(study.studyUuid)">Create Respondents</v-btn>
												</div>
											</v-card>
										</v-col>
									</v-row>
								</v-card>
							</v-col>
						</v-row>

					</div>
        </v-col>
				<v-col
          :sm="5"
					md="4"
					lg="3"
					class="help-div-container"
        >
					<div class="help-div">
						<help :displayAlterText="displayAlterText" :draftStudyId="draftStudyId"></help>
					</div>
        </v-col>
      </v-row>
		</v-container>
	</div>
</template>

<script>
import { utilityService } from '@/services/utilityService';
export default {
	name: 'LandingPage',
	props: {
	},
	metaInfo: {
		title: 'Home'
	},
	data: () => ({
		displayAlterText: false,
		draftStudyId: null,
		sortItems: ['Name', 'Start Date', 'End Date', 'Abbreviation'],
		selectedSort: 'Name',
		studies: []
	}),
	created () {
		window.addEventListener('keydown', (e) => {
			this.nextTab(e)
		});
	},
	async mounted () {
		window.scrollTo(0, 0);
		this.$refs.firstFocusable.focus();

		// Reset the study tabs
		this.$store.commit('setCurrentStudyTab', { tabIndex: 0, subTabIndex: 0 });
		this.$store.dispatch('refreshOneStudy')
	},
	methods: {
		studyClicked (id, status) {
			// Used for the study home page view and for finishing saved and draft studies
			this.$store.commit('setSelectedStudyUuid', { id });

			if (status && status.toLowerCase() === 'created') {
				this.$router.push('/study/home').catch(err => {
					console.log('Navigating to study home overriden by navigation guard');
				});
			} else {
				this.$router.push('/create/study').catch(err => {
					console.log('Navigating to create study overriden by navigation guard');
				});
			}
		},
		onNewStudy () {
			if (this.displayAlterText) {
				var id = this.draftStudyId;
				this.$store.commit('setSelectedStudyUuid', { id });
			}

			this.$router.push('/create/study').catch(err => {
				console.log('Navigating to create study overriden by navigation guard');
			});
		},
		isEmpty (obj) {
			// if the studies only contain one study and it is a draft, it should display the no studies default card
			if (Object.keys(obj).length === 0) {
				return true
			} else if (Object.keys(obj).length === 1 && this.displayAlterText) {
				return true;
			} else {
				return false
			}
		},
		getStatus (dateStart, dateEnd, status) {
			// If the study is a draft, there might not be a date value with it.
			if (status && status.toLowerCase() !== 'created') {
				return this.statusList[3];
			}

			var d = new Date();
			var currentTimestamp = d.getTime();
			d = new Date(dateEnd);
			var endTimestamp = d.getTime();

			if (currentTimestamp < endTimestamp) {
				d = new Date(dateStart);
				var startTimestamp = d.getTime();
				// NOTE: The values bellow are based on the position of the status in the property
				// assets/global_text/studyStatusList.
				if (currentTimestamp > startTimestamp) {
					return this.statusList[0];
				} else {
					return this.statusList[1];
				}
			} else {
				return this.statusList[2];
			}
		},
		convertToDate (dateStr) {
			var d = new Date(dateStr);
			var month = d.getUTCMonth() + 1;
			var day = d.getUTCDate();
			var year = d.getUTCFullYear();

			return month + '/' + day + '/' + year;
		},
		getStudyToolInfo (study) {
			// NOTE: The values bellow are based on the position of the type in the property
			// assets/global_text/studyTypeList.
			if (study.studyTool === 'RECALL') {
				return this.typeList[1];
			} else if (study.studyTool === 'RECORD') {
				return this.typeList[2];
			} else {
				return this.typeList[0];
			}
		},
		getStudyTypeInfo (studyTool, recordStudyType, recallType) {
			// NOTE: The values bellow are based on the position of the type in the property
			// assets/global_text/studyTypeList.
			if (studyTool === 'RECORD') {
				if (recordStudyType !== null && recordStudyType.toLowerCase() === 'consecutive_day') {
					return this.typeList[3];
				} else if (recordStudyType !== null && recordStudyType.toLowerCase() === 'single_day') {
					return this.typeList[4];
				} else {
					return this.typeList[0];
				}
			} else if (studyTool === 'RECALL') {
				if (recallType !== null && recallType.toLowerCase() === 'unscheduled') {
					return this.typeList[5];
				} else if (recallType !== null && recallType.toLowerCase() === 'scheduled') {
					return this.typeList[6];
				} else {
					return this.typeList[0];
				}
			} else {
				return this.typeList[0];
			}
		},
		getStudyVersionDescription (versionId) {
			const studyVersion = this.$store.getters.getStudyVersion(versionId);
			return studyVersion ? studyVersion.versionName : versionId;
		},
		async onNewRespondents (id) {
			// Update the store with the selected study identifier
			this.$store.commit('setSelectedStudyUuid', { id });
			// Set the tab we want to navigate to
			const tabsPos = await utilityService.getTabsPositionByName('Add new Respondents', this.$studyTabConfig);
			const tabs = { tabIndex: tabsPos.tabPos, subTabIndex: tabsPos.subtabPos };
			this.$store.commit('setCurrentStudyTab', tabs);

			// Navigate to the study details component
			this.$router.push('/study/home').catch(err => {
				console.log('Navigating to study home overriden by navigation guard');
			});
		},
		sortStudies (studies, studiesSortProperty) {
			switch (studiesSortProperty) {
			case 'Name':
				studies.sort((a, b) => { return (a.studyName ? a.studyName.toLowerCase() : '').localeCompare((b.studyName ? b.studyName.toLowerCase() : '')); })
				break;
			case 'Start Date':
				studies.sort((a, b) => { return a.dateStart - b.dateStart; })
				break;
			case 'End Date':
				studies.sort((a, b) => { return a.dateEnd - b.dateEnd; })
				break;
			case 'Abbreviation':
				studies.sort((a, b) => { return (a.studyId ? a.studyId.toLowerCase() : '').localeCompare((b.studyId ? b.studyId.toLowerCase() : '')); })
				break;
			}
			return studies;
		},
		nextTab (e) {
			var activeEl = document.activeElement
			if (activeEl.classList.contains('study-card-title')) {
				var universe = document.querySelectorAll('.study-card-title');
				var list = Array.prototype.filter.call(universe, function (item) { return item.tabIndex >= '0' });
				list.shift()
				var index = list.indexOf(activeEl);
				var nextEl
				if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
					nextEl = list[index + 1] || list[0];
					nextEl.focus()
				}
				if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
					nextEl = list[index - 1] || list[list.length - 1];
					nextEl.focus()
				}
			}
		},
		focusToTop () {
			console.log('focus 2 top')
			var myHeader = document.getElementById('skipToMain')
			myHeader.focus()
		}
	},
	computed: {
		storeStudies: function () {
			this.focusToTop()
			const studiesSortProperty = this.$store.getters.getStudiesSortProperty;
			const studies = this.$store.getters.getStudiesArray;
			const me = this;
			// Handle drafts
			studies.forEach(study => {
				if ((study.currentStudyStatus ? study.currentStudyStatus.toLowerCase() : '') === 'draft') {
					me.displayAlterText = true;
					me.draftStudyId = study.studyUuid;
				}
			});

			if (studies !== null) {
				return this.sortStudies(studies, studiesSortProperty);
			}

			return studies;
		},
		studiesSortProperty: {
			get: function () {
				return this.$store.getters.getStudiesSortProperty;
			},
			set: function (newVal) {
				this.$store.commit('setStudiesSortProperty', { studiesSortProperty: newVal });
			}
		},
		userInfo: function () {
			return this.$store.getters.getUserInfo;
		},
		statusList: function () {
			return this.$studyStatusList.cardStatusList;
		},
		typeList: function () {
			return this.$studyTypeList;
		}
	}
}
</script>

<style>
/* Align the H1 Hello with the study card content */
.header-left-align {
	margin-left: 10px;
}
</style>
